import { Http } from '../../shared';
import { settings } from '../../settings';

export class IdentityService {
    constructor() {
        this.http = new Http();
        this.service_url = settings.base_api;
    }
    
    async signin(data) {     
        var response = await this.http.post(this.service_url + '/identity/signin', data);
        return response.data;
    }
    async signout() {      
        var response = await this.http.post(this.service_url + '/identity/signout', {});
        return response.data;
    }
    async changePassword(data) {
        var response = await this.http.post(this.service_url + '/identity/change-password', data);
        return response.data;
    }

    async sendPasswordResetEmail(data) {
        var response = await this.http.post(this.service_url + '/emails/account/password-reset/send', data);
        return response.data;
    }
    async resetPassword(data) {
        var response = await this.http.post(this.service_url + '/identity/reset-password', data);
        return response.data;
    }
}
